// WorkspaceAttributeApi — the three attribute write endpoints (contract 22 §6.1 rows 2-4), the
// only HTTP importer in this feature's attribute spine (canonical api/ contract 03 §15).
//
// The READ half is 07's: boot hydrates the blob and `useWorkspace().refreshAttributes()` re-reads
// it (CM-22-01), so `settings/key-event/list/` deliberately does not live here.
//
// `suppressGlobalErrorHandler` is the class default — a settings pane owns its own error UX; a
// failed save is an inline row state, never a global toast (§6).
import type { AxiosInstance } from 'axios'

import type { AttributeWriteVerb } from '../service/attributeEnvelope'

import { appHttp, unwrapEnvelope } from '@/shared/http'

export interface AttributeWriteParams {
  verb: AttributeWriteVerb
  accountId: number | string
  workspaceId: number | string
  body: Record<string, unknown>
}

export class WorkspaceAttributeApi {
  // Injectable for tests; defaults to the singleton instance.
  constructor(private readonly http: AxiosInstance = appHttp) {}

  private readonly cfg = { suppressGlobalErrorHandler: true } as const

  /** POST `/accounts/{a}/workspaces/{w}/settings/key-event/{create|update|delete}/`. The verb IS
   *  the path segment — `attributeVerb` picks it and `attributeBody` shapes the body; this class
   *  transports them and never re-derives either. Enveloped route (`{status,data}`), so a
   *  `status:'error'` body throws an `ApiError` rather than resolving with a bad payload. */
  async write({ verb, accountId, workspaceId, body }: AttributeWriteParams): Promise<unknown> {
    return unwrapEnvelope(
      await this.http.post(
        `/accounts/${accountId}/workspaces/${workspaceId}/settings/key-event/${verb}/`,
        body,
        this.cfg,
      ),
    )
  }
}

export const workspaceAttributeApi = new WorkspaceAttributeApi()
